import TextInput from "components/form/input/TextInput"
import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields"
import MudaManual from ".."

export function ParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={MudaManual.field + tipoIndicadorField}
            tabFields={
                <>
                    <ParamFormRow label="Observação">
                        <TextInput name="obs" label="Observação" />
                    </ParamFormRow>
                    <ParamFormRow label="Meta Desponte (perdas)">
                        <TextInput name="despontePerdas" label="Desponte (perdas) (%)" type="number" />
                    </ParamFormRow>
                    <ParamFormRow label="Meta Desponte (Não Despontada)">
                        <TextInput name="desponteNaoDespontada" label="Desponte (Não Despontada) (%)" type="number" />
                    </ParamFormRow>
                    <ParamFormRow label="Meta Gemas Danificadas (Facão)">
                        <TextInput name="gemasDanificadasFacao" label="Gemas Danificadas (Facão) (%)" type="number" />
                    </ParamFormRow>
                    <ParamFormRow label="Meta Gemas Danificadas (Praga e Clima)">
                        <TextInput name="gemasDanificadasPragaClima" label="Gemas Danificadas (Praga e Clima) (%)" type="number" />
                    </ParamFormRow>
                </>
            }
        />
    )
}
